<template>
    <main class="HistorialView-MAIN DISPLAY">
    <main class="INNER-MARGIN">

        <img src="../assets/historial-tus-cupones.png"/>
        <div>
            <a v-for="(item, index) in favorites" :key="index" :href="getFrontURL()+'/cupon/?cupon='+item.id"><img :src="item.url_banner"/></a>
        </div>

        <img src="../assets/historial-cupones-canjeados.png"/>
        <div>
            <a v-for="(item, index) in downloads" :key="index" :href="getFrontURL()+'/cupon/?cupon='+item.id"><img :src="item.url_banner"/></a>
        </div>

    </main>
    </main>
</template>

<script>
export default{
    name: 'HistorialView',
    data(){
        return{
            favorites: [],
            downloads: [],
        }
    },
    methods: {
        async getFavorites(){
            const response = await fetch('https://promo-colaboradores.ideeo.mx/api/mis-favoritos', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    usuario_id: JSON.parse(localStorage.getItem("userData")).usuario_id,
                })
            });
            const result = await response.json();
            console.log("Mis favoritos", result)
            if(result.msg == "Estos son tus favoritos."){
                this.favorites = result.data;
            }
        },
        
        async getDownloaded(){
            const response = await fetch('https://promo-colaboradores.ideeo.mx/api/mis-descargas', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    usuario_id: JSON.parse(localStorage.getItem("userData")).usuario_id,
                })
            });
            const result = await response.json();
            console.log("Mis descargas", result)
            if(result.msg == "Estas son tus descargas."){
                this.downloads = result.data;
            }
        },

        getFrontURL(){
			return window.location.origin;
		},
    },
    mounted(){
        this.getFavorites();
        this.getDownloaded();
    }
}
</script>

<style scoped>
.HistorialView-MAIN{
    background-color: #FFDEEC;
}

.INNER-MARGIN{
    display: flex;
    flex-direction: column;
    align-items: center;
}

.INNER-MARGIN > img{
    height: 3.3ch;
}

.INNER-MARGIN > div{
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    grid-gap: 1ch;
    margin-top: 3ch;
    margin-bottom: 6ch;
    width: 90%;
}

.INNER-MARGIN > div img{
    width: 100%;
}

/* RESPONSIVE */
@media all and (max-width:780px){

    .INNER-MARGIN > img{
        height: 8vw;
    }

    .INNER-MARGIN > div{
        grid-template-columns: 1fr 1fr;
    }

}
</style>